/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Checked_InInputs */

const en_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`checked in`)
};

const de_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eingecheckt`)
};

const es_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`check-ins registrados`)
};

const fr_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`check-in enregistré`)
};

const nl_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ingecheckt`)
};

const it_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registrato`)
};

const pt_br2_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fizeram check-in`)
};

const pl_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zameldowano`)
};

const hu_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`van becsekkolva`)
};

const ro_admin_dashboard_checked_in = /** @type {(inputs: Admin_Dashboard_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inregistrat`)
};

/**
* | output |
* | --- |
* | "checked in" |
*
* @param {Admin_Dashboard_Checked_InInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_checked_in = /** @type {((inputs?: Admin_Dashboard_Checked_InInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Checked_InInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_checked_in(inputs)
	if (locale === "de") return de_admin_dashboard_checked_in(inputs)
	if (locale === "es") return es_admin_dashboard_checked_in(inputs)
	if (locale === "fr") return fr_admin_dashboard_checked_in(inputs)
	if (locale === "nl") return nl_admin_dashboard_checked_in(inputs)
	if (locale === "it") return it_admin_dashboard_checked_in(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_checked_in(inputs)
	if (locale === "pl") return pl_admin_dashboard_checked_in(inputs)
	if (locale === "hu") return hu_admin_dashboard_checked_in(inputs)
	return ro_admin_dashboard_checked_in(inputs)
});
export { admin_dashboard_checked_in as "admin.dashboard.checked_in" }